import React from "react";

const ExploreHeader = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1440"
      height="29"
      viewBox="0 0 1440 29"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 1.55177C0 1.55177 637.77 62.7881 1440 1.55177V-8.33008L0 -8.33008V1.55177Z"
        fill="white"
      />
    </svg>
  );
};

export default ExploreHeader;
